import { useEffect, useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import {
  USER_MAKE_PAYMENT_TO_SUBSCRIPTION_UNPAID_BEGIN,
  USER_MAKE_PAYMENT_TO_SUBSCRIPTION_UNPAID_SUCCESS,
  USER_MAKE_PAYMENT_TO_SUBSCRIPTION_UNPAID_FAILURE,
  USER_MAKE_PAYMENT_TO_SUBSCRIPTION_UNPAID_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import config from '../../../common/config';
import { createAxiosConfigWithAuth } from '../../../common/apiHelpers';

export function makePaymentToSubscriptionUnpaid(args = {}) {
  return (dispatch, getState) => {
    // optionally you can have getState as the second argument
    dispatch({
      type: USER_MAKE_PAYMENT_TO_SUBSCRIPTION_UNPAID_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${config.apiRootUrl}/subscriptions/make-payment-to-subscription-unpaid`,
        args,
        createAxiosConfigWithAuth(getState()),
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: USER_MAKE_PAYMENT_TO_SUBSCRIPTION_UNPAID_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: USER_MAKE_PAYMENT_TO_SUBSCRIPTION_UNPAID_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissMakePaymentToSubscriptionUnpaidError() {
  return {
    type: USER_MAKE_PAYMENT_TO_SUBSCRIPTION_UNPAID_DISMISS_ERROR,
  };
}

export function useMakePaymentToSubscriptionUnpaid() {
  const dispatch = useDispatch();

  const {
    makePaymentToSubscriptionUnpaidPending,
    makePaymentToSubscriptionUnpaidError,
  } = useSelector(
    (state) => ({
      makePaymentToSubscriptionUnpaidPending:
        state.user.makePaymentToSubscriptionUnpaidPending,
      makePaymentToSubscriptionUnpaidError:
        state.user.makePaymentToSubscriptionUnpaidError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback(
    (...args) => {
      return dispatch(makePaymentToSubscriptionUnpaid(...args));
    },
    [dispatch],
  );

  const boundDismissError = useCallback(() => {
    return dispatch(dismissMakePaymentToSubscriptionUnpaidError());
  }, [dispatch]);

  return {
    makePaymentToSubscriptionUnpaid: boundAction,
    makePaymentToSubscriptionUnpaidPending,
    makePaymentToSubscriptionUnpaidError,
    dismissMakePaymentToSubscriptionUnpaidError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case USER_MAKE_PAYMENT_TO_SUBSCRIPTION_UNPAID_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        makePaymentToSubscriptionUnpaidPending: true,
        makePaymentToSubscriptionUnpaidError: null,
      };

    case USER_MAKE_PAYMENT_TO_SUBSCRIPTION_UNPAID_SUCCESS:
      // The request is success
      return {
        ...state,
        makePaymentToSubscriptionUnpaidPending: false,
        makePaymentToSubscriptionUnpaidError: null,
      };

    case USER_MAKE_PAYMENT_TO_SUBSCRIPTION_UNPAID_FAILURE:
      // The request is failed
      return {
        ...state,
        makePaymentToSubscriptionUnpaidPending: false,
        makePaymentToSubscriptionUnpaidError: action.data.error,
      };

    case USER_MAKE_PAYMENT_TO_SUBSCRIPTION_UNPAID_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        makePaymentToSubscriptionUnpaidError: null,
      };

    default:
      return state;
  }
}
